module.exports = __webpack_public_path__ + "media/bg1.2686da24.mp4";